import addInfoBarMessage from './addInfoBarMessage';
import datapoints from '../datapoints';
import showCcWell from './showCcWell';
import updateDockingHeight from '../plugins/docking/actions/updateDockingHeight';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { action } from 'satcheljs/lib/legacy';
import { getTopDockingHeight, getBottomDockingHeight, } from '../plugins/docking/utils/getDockingHeight';
import convertInlineCss from 'roosterjs-editor-dom/lib/utils/convertInlineCss';
import { findComposePlugins } from '../plugins/ComposePlugins';
export default action('upConvert', datapoints.MailComposeUpConvert)(function upConvert(viewState) {
    if (viewState.bodyType == 'HTML') {
        viewState.isRibbonShown = true;
    }
    var plugins = findComposePlugins(viewState);
    if (plugins) {
        if (plugins.undo) {
            plugins.undo.clear();
        }
        var contentOperationPlugin = plugins.contentOperationPlugin;
        if (contentOperationPlugin) {
            contentOperationPlugin.updateContentToViewState();
            contentOperationPlugin.stopSaveOnDispose();
        }
    }
    if (viewState.quotedBody) {
        // Clean global CSS and convert to inline CSS if any, so that global CSS will not impact new content
        var quotedBody = convertInlineCss(viewState.quotedBody);
        viewState.content = viewState.content + quotedBody;
        viewState.useSmartResponse = false;
    }
    else {
        addInfoBarMessage(viewState, 'warningNoQuotedBody');
    }
    viewState.isInlineCompose = false;
    if (!isConsumer()) {
        showCcWell(viewState);
    }
    updateDockingHeight(viewState.docking, getTopDockingHeight(viewState.isInlineCompose), getBottomDockingHeight(viewState.isRibbonShown, viewState.isInlineCompose));
});
//# sourceMappingURL=upConvert.js.map